<template>
  <v-container>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
    >
      <v-card-title class="title font-weight-light">
        Recurrence Booking Request
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search by user or asset name"
          single-line
          hide-details
        />
      </v-card-title>
      <div class="d-flex">
        <v-checkbox
          v-model="showHistory"
          :label="`Show historical data`"
          class="mt-5 ml-auto"
          @click="handleShowHistory"
        />
      </div>
      <v-data-table
        :headers="headers"
        :items="dataApi"
        item-key="book_id"
        sort-by="book_detail.start_datetime"
        class="font-weight-light"
        :loading="loadingRequest"
        loading-text="Loading..."
        :search="searchData"
        :footer-props="footerProps"
        @update:options="updatePaging"
        :server-items-length="total"
        :options.sync="paginationOptions"
      >
        <template #[`item.no`]=" { item }">
          {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + dataApi.indexOf(item) + 1 }}
        </template>
        <template #[`item.book_detail.start_geofence_id`]="{ item }">
          {{ getOriginName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_geofence_id`]="{ item }">
          {{ getDestinationAddr(item.book_detail) }}
        </template>
        <template #[`item.book_detail.vehicle_name`]="{ item }">
          {{ getVehicleName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.start_datetime`]=" { item }">
          {{ startDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_datetime`]=" { item }">
          {{ endDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.created_at`]=" { item }">
          {{ dateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.recurring`]=" { item }">
          <div>
            <v-tooltip
              bottom
              :open-delay="500"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <span v-if="item.book_detail.passenger">Passenger Info :</span>
              <table v-if="item.book_detail.passenger">
                <tbody>
                  <tr
                    v-for="r in item.book_detail.passenger"
                    :key="r.user_id"
                  >
                    <td>{{ r.first_name }} {{ r.last_name }} {{ handleOwner(r) }}</td>
                    <td> &nbsp; - &nbsp; </td>
                    <td>{{ r.passenger_count }} Passenger</td>
                  </tr>
                </tbody>
              </table>
              <br>
              <span v-if="item.book_detail.recurring == '1'">Recurring Info :</span>
              <table v-if="item.book_detail.booking_recurring">
                <tbody>
                  <tr
                    v-for="r in item.book_detail.booking_recurring"
                    :key="r.id"
                  >
                    <td>{{ formatDate(r.start_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                    <td> &nbsp; - &nbsp; </td>
                    <td>{{ formatDate(r.end_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                  </tr>
                </tbody>
              </table>
            </v-tooltip>
          </div>
        </template>
        <template #[`item.book_detail.status`]="{ item }">
          <div v-if="item.book_detail.status == 1">
            <v-chip
              small
              color="warning"
              class="font-weight-bold"
            >
              {{ setStatus(item) }}
            </v-chip>
          </div>
          <div v-if="item.book_detail.status == 3">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-chip
                  small
                  color="error"
                  class="font-weight-bold"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ setStatus(item) }}
                </v-chip>
              </template>
              <span>{{ setTextReject(item.book_detail) }}</span>
            </v-tooltip>
          </div>
          <!-- <v-chip small :color="item.book_detail.status == 2" class="font-weight-bold">
              {{setStatus(item.book_detail)}}
            </v-chip> -->
        </template>

        <template #[`item.action`]="{ item }">
          <v-icon
            small
            color="green"
            class="mr-2"
            @click="setItem(item, 0)"
            v-if="(($store.state.user.user.type == 1 || $store.state.user.user.type == 3) && item.book_detail.status == 1) || item.request_share_ride"
          >
            mdi-check
          </v-icon>
          <v-icon
            small
            color="red"
            @click="setItem(item, 1)"
            v-if="(($store.state.user.user.type == 1 || $store.state.user.user.type == 3) && item.book_detail.status == 1) || item.request_share_ride"
          >
            mdi-close
          </v-icon>
          <v-icon
            small
            @click="cancelBooking(item)"
            color="red"
            v-if="item.book_detail.status == 3"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="warning"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Are you sure to want to
              approve this booking?
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="clearItem"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="approveBooking"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog2"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="warning"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Are you sure to want to
              reject this booking?
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="dialog2 = false"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="closeAndShow"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog3"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="secondary"
        >
          <v-card-title>
            <v-text-field
              label="Reason for reject this booking"
              outlined
              required
              v-model="reason"
              :rules="[(v) => !!v || 'Reason is required']"
            />
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="clearItem"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="rejectBooking"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deldialog"
        persistent
        max-width="560"
      >
        <v-card
          dark
          color="red"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
              this booking?
            </span>
          </v-card-title>
          <v-card-text>
            You will delete this booking permanently.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="deldialog = false"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="submitDeleteBooking()"
              :loading="loadingUpdate"
              :disabled="loadingUpdate"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import isNull from 'lodash/isNull';
import isUndefined from "lodash/isUndefined";
import moment from "moment";
import get from "lodash/get";

export default {
  data: () => ({
    clientid: "",
    reason: "",
    headers: [
      { text: "No", value: "no", sortable: false },
      { text: 'First Name', align: 'left', value: 'first_name' },
      { text: 'Last Name', align: 'left', value: 'last_name' },
      { text: 'From', value: 'book_detail.start_geofence_id', sortable: false },
      { text: 'To', value: 'book_detail.end_geofence_id', sortable: false },
      { text: 'Start Date', value: 'book_detail.start_datetime' },
      { text: 'End Date', value: 'book_detail.end_datetime' },
      { text: 'Vehicle Name', value: 'book_detail.vehicle_name' },
      { text: 'Created At', value: 'book_detail.created_at' },
      { text: 'Info', value: 'book_detail.recurring', sortable: false},
      { text: 'Status', value: 'book_detail.status' },
      { text: "Actions", value: "action", sortable: false },
    ],
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
    searchTimeout: 0,
    total: 0,
    dataApi: [],
    loadingRequest: false,
    searchData: "",
    dialog: false,
    dialog2: false,
    dialog3: false,
    itemBooking: null,
    deldialog: false,
    deleteTarget: [],
    loadingUpdate: false,
    showHistory: false
  }),
  created() {
    this.clientid = this.$store.state.clientid;
    this.$store.dispatch('LOAD_DESTINATION_DATA')
    if (this.$store.state.type == 3) {
      this.$store.dispatch("GET_ALL_GEOFENCES");
    } else {
      this.$store.dispatch("GET_GEOFENCES");
    }
  },
  watch: {
    searchData() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];

        this.getTotal();
        this.getData();
      }, 500)
    },
  },
  methods: {
    submitDeleteBooking() {
      // this.loadingUpdate = true;
      this.$store.dispatch('API_CALL', {
        $method: 'delete_book',
        $postData: {
          book_id: this.deleteTarget.book_id,
        },
      })
      .then((response) => {
        if(response.data.code == 200) {
          this.deldialog = false
          this.loadingUpdate = false;
          this.$swal({
            icon: "success",
            title: response.data.data.message,
          });
          Promise.all([
            this.getTotal(),
            this.getData(),
          ]).then(() => {
            // Total data ada, tapi di page ini kosong
            if (this.total > 0 && this.dataApi.length === 0) {
              // reset page ke page 1
              this.paginationOptions.page = 1
              this.getTotal();
              this.getData();
            }
          })
          // this.getBookData.splice(userIndex, 1);
        } else {
          this.$swal({
            icon: "error",
            title: response.data.data.message,
          });
        }
      });
    },
    closeAndShow() {
      this.dialog2 = false;
      this.dialog3 = true;
    },
    cancelBooking(item) {
      this.deldialog = true;
      this.deleteTarget = item;
    },
    handleOwner(item) {
      let text = ''
      if(item.is_owner == '1'){
        text = '(Owner)'
      }
      return text
    },
    formatDate(date, format = 'D MMM YYYY HH:mm') {
      if (date == null) return;
      const dateFormatted = moment(date).format(format)
      return dateFormatted;
    },
    setItem(item, action) {
      this.itemBooking = item;
      return !action ? this.dialog = true : this.dialog2 = true;
    },
    clearItem() {
      this.itemBooking = null;
      this.dialog = false;
      this.dialog3 = false;
    },
    approveBooking() {
      this.dialog = false;
      let data = "";
      data = {
        id: this.itemBooking.book_id,
        status: 2,
        send_email: 1,
      };
      this.$store.dispatch('API_CALL', {
        $method: 'update_book',
        $postData: {
          data: data
        },
      }).then(
        (response) => {
          if (response !== null) {
            this.getTotal();
            this.getData();
          }

          if(response.data.code == 200) {
            this.$swal({
              icon: 'success',
              title: response.data.data.message,
              text: 'Go to calendar menu if you want to see your schedule information',
            })
          } else {
            this.$swal({
              icon: 'error',
              title: response.data.data.message,
            })
          }
        })
    },
    setStatus(item) {
      let status = null;
      if (item.book_detail.status == 1) {
        status = "Requested";
      } else if (item.book_detail.status == 2) {
        status = "Approved";
      } else if (item.book_detail.status == 3) {
        status = "Rejected";
      }
      if (item.request_share_ride) status = "Request Join"
      return status;
    },
    setTextReject(item){
      let text = "-"
      if(item.hasOwnProperty("metadata")) {
        let metadata = JSON.parse(item.metadata)
        text = get(metadata, "reason", "-")
      }
      return text;
    },
    rejectBooking() {
      this.dialog3 = false;
      const metadata = {
        reason: this.reason,
      };
      let data = "";
      data = {
        id: this.itemBooking.book_id,
        status: 3,
        metadata: metadata,
        send_email: 1,
      };
      this.$store.dispatch('API_CALL', {
        $method: 'update_book',
        $postData: {
          data: data
        },
      }).then(
        (response) => {
          if(response.data.code == 200) {
            this.$swal({
              icon: 'success',
              title: "Success reject booking",
            })
            this.getTotal();
            this.getData();
          } else {
              this.$swal({
              icon: 'error',
              title: response.data.data.message,
            })
          }
        })
    },
    getOriginName(item) {
       if (item == null) return;
      let destination = "";
      if (item.start_geofence_id != 0) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.start_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            const geofenceDestination = group.geofences.find(
              (geofence) =>
                parseInt(geofence.Id) === parseInt(item.start_geofence_id)
            );
            if (!isUndefined(geofenceDestination)) {
              destination = geofenceDestination.name;
            }
          });
        }
      }
      return destination;
    },
    getDestinationAddr(item) {
      if (item == null) return;
      let destination = "";
      let stopFind = false;
      if (item.end_geofence_id != 0 && !isNull(item.end_geofence_id)) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              if (stopFind === false) {
                const geofenceDestination = group.geofences.find(
                  (geofence) =>
                    parseInt(geofence.Id) === parseInt(item.end_geofence_id)
                );
                if (!isUndefined(geofenceDestination)) {
                  destination = geofenceDestination.name;
                  stopFind = true;
                }
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            if (stopFind === false) {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.end_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
                stopFind = true;
              }
            }
          });
        }
      } else if (item.metadata && item.metadata.hasOwnProperty("address")) {
        destination = item.metadata.hasOwnProperty("address")
          ? item.metadata.address
          : `${item.start_longitude},${item.end_longitude}`;
      } else if (isNull(item.end_geofence_id)) {
        const destination = JSON.parse(item.metadata);
        return destination.address;
      } else {
        const destination = JSON.parse(item.metadata);
        return destination.address;
      }
      return destination;
    },
    getVehicleName(item) {
      if (item == null) return

      let metadata = ""
      if(item.hasOwnProperty("vehicle_name")){
        metadata = `Vehicle - ${item.vehicle_name}`;
      } else if(!isNull(item.asset_id)){
        metadata = `${item.asset_type} - ${item.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return
      return metadata
    },
    dateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("created_at")){
        date =  moment(item.created_at).format('dddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    startDateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("start_datetime")){
        date =  moment(item.start_datetime).format('dddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    endDateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("end_datetime")){
        date =  moment(item.end_datetime).format('ddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    getTotal() {
      let user_id = null;

      if (this.$store.state.type == 2 || this.$store.state.type == 4) user_id = this.$store.state.user.user.id;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_book_total',
          $postData: {
            clientid: this.$store.state.clientid,
            status: [1, 3],
            query: this.searchData,
            user_id
          },
        })
        .then((response) => {
          this.total = parseInt(response.data.data.total);
        });
    },
    getData() {
      this.loadingRequest = true;
      const { clientid } = this.$store.state;
      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by    = sortBy.length ? sortBy[0] : 'status';
      const sort_dir   = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset     = (page - 1) * itemsPerPage
      const limit      = itemsPerPage

      const skip_past_date = this.showHistory ? 0 : 1;

      let by = 'status';

      switch(sort_by) {
        case 'first_name':
            by = 'first_name';
            break;
        case 'last_name':
            by = 'last_name';
            break;
        case 'book_detail.start_datetime':
            by = 'start_date';
            break;
        case 'book_detail.end_datetime':
          by = 'end_date';
            break;
        case 'book_detail.status':
          by = 'status';
          break;
        default:
          break;
      }
      const postData = {
        query: this.searchData,
        offset,
        limit,
        sort_by: by,
        sort_dir,
        get_recurring: 1,
        get_schedules: 1,
        skip_past_date
      };
      if(this.$store.state.type == 3) { // System admin
        postData.status = [1, 3];
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.loadingRequest = false;
          const userBooks = response.data.data.filter(book => book.user_id == this.$store.state.user.user.id)
          let userRequest = response.data.data.filter(book => {
            if (book.book_detail.join_with == null) return false
            const matchBook = userBooks.find(u => u.book_detail.id == book.book_detail.join_with)
            return matchBook && parseInt(book.book_detail.status) == 1
          })
          userRequest = userRequest.map(book => ({
            ...book,
            request_share_ride: true
          }));
          const temporaryData = response.data.data.filter(booking => {
            const isShareRide = userRequest.find(u => u.book_detail.id == booking.book_detail.id)
            return (booking.book_detail.status == 1 || booking.book_detail.status == 3) && !isShareRide
          });
          this.dataApi = [...temporaryData, ...userRequest];
        })
      } else if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        postData.user_id = this.$store.state.user.user.id;
        postData.clientid = clientid;
        postData.get_request_join = 1;
        postData.status = [1, 3];
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.loadingRequest = false;
          const userBooks = response.data.data.filter(book => book.user_id == this.$store.state.user.user.id)
          let userRequest = response.data.data.filter(book => {
            if (book.book_detail.join_with == null) return false
            const matchBook = userBooks.find(u => u.book_detail.id == book.book_detail.join_with)
            return matchBook && parseInt(book.book_detail.status) == 1
          })
          userRequest = userRequest.map(book => ({
            ...book,
            request_share_ride: true
          }));
          const temporaryData = response.data.data.filter(booking => {
            const isShareRide = userRequest.find(u => u.book_detail.id == booking.book_detail.id)
            return (booking.book_detail.status == 1 || booking.book_detail.status == 3) && !isShareRide
          });
          this.dataApi = [...temporaryData, ...userRequest];
        })
      } else if (this.$store.state.type == 1) {
        postData.clientid = clientid;
        postData.status = [1, 3];
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.loadingRequest = false;
          // this.dataApi = response.data.data.filter(booking => booking.book_detail.status == 1 || booking.book_detail.status == 3)
          const userBooks = response.data.data.filter(book => book.user_id == this.$store.state.user.user.id)
          let userRequest = response.data.data.filter(book => {
            if (book.book_detail.join_with == null) return false
            const matchBook = userBooks.find(u => u.book_detail.id == book.book_detail.join_with)
            return matchBook && parseInt(book.book_detail.status) == 1
          })
          userRequest = userRequest.map(book => ({
            ...book,
            request_share_ride: true
          }));
          const temporaryData = response.data.data.filter(booking => {
            const isShareRide = userRequest.find(u => u.book_detail.id == booking.book_detail.id)
            return (booking.book_detail.status == 1 || booking.book_detail.status == 3) && !isShareRide
          });
          this.dataApi = [...temporaryData, ...userRequest];
        })
      }
    },
    updatePaging(options) {
      this.getTotal();
      this.paginationOptions = options;
      this.getData();
    },
    handleShowHistory() {
      this.getTotal();
      this.getData();
    }
  },
  computed: {
      all_geofences() {
        return this.$store.getters["getAllGeofencesData"];
      },
      geofences() {
        return this.$store.getters["getGeofencesData"];
      },
  }
};
</script>
<style>
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-html {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-input {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
</style>
